import { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { SVG, Text, SelectBox } from "sunrise-ui";
import { engineerDetails } from "../Utilites/Utilities";
import dateFormat from "../../../utilities/dateFormat";
import { AppDispatch } from "../../../redux/store";
import {
  getStepLevelDetails,
  getPileLevelDetails,
  getEngineerLevelDetails,
} from "../../../redux/reducers/dashboardReducers";
import { timeFormatter } from "../../../utilities/timeHandler";

const WorkInProgressPilesDrawer = (props: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const { data } = props;
  const [step, setStep] = useState("");
  const [shift, setShift] = useState({ short: "DAY", long: "Morning Shift" });
  const [engineerLevelDetails, setEngineerLevelDetails] = useState<any[]>();
  const [engStartStep, setEngStartStep] = useState(false);
  const [engCompletedStep, setEngCompletedStep] = useState(false);
  const [stepsDropData, setStepsDopData] = useState<any>([]);
  const stepLevelDetail = useSelector(
    (state: any) => state.DASHBOARD.stepLevelDetails
  );

  const pileLevelDetail = useSelector(
    (state: any) => state.DASHBOARD.pileLevelDetails
  );

  const engineerLevelDetail = useSelector(
    (state: any) => state.DASHBOARD.engineerLevelDetails
  );

  const stepDropList = useSelector(
    (state: any) => state.DASHBOARD.stepsDropList
  );
  console.log(shift);

  // Toggle Eng Works
  const startStepToggle = () => setEngStartStep(!engStartStep);
  const completedStepToggle = () => setEngCompletedStep(!engCompletedStep);

  // changing pile levele details
  useEffect(() => {
    setEngineerLevelDetails(engineerDetails);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (data?.id) {
      // Pile Level Detials
      dispatch(
        getPileLevelDetails({
          endPoint: `piles/details?id=${data?.id}`,
        })
      );
    }
    // eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if (data?.id) {
      dispatch(
        getEngineerLevelDetails({
          endPoint: `piles/engineer-details?shift=${shift.short}&pileId=${data?.id}`,
        })
      );
    }
    // eslint-disable-next-line
  }, [shift]);

  useEffect(() => {
    if (data?.id) {
      // Step Level Detials
      if (step === "") {
        const Data = stepDropList;
        const list = Data.map(
          (val: any) =>
            `Step ${val.number}, ${
              val.name[0].toUpperCase() + val.name.slice(1).toLowerCase()
            }`
        );
        if (list.length > 0) setStep(list[0]);
        setStepsDopData(list);
        if (Data?.length > 0) {
          dispatch(
            getStepLevelDetails({
              endPoint: `piles/step-details?pileId=${data?.id}&stepNumber=${Data[0].number}&stepName=${Data[0].name}`,
            })
          );
        }
      } else {
        const data2 = stepDropList.find(
          (val: any) => val.number === +step.substring(5, 6)
        );
        dispatch(
          getStepLevelDetails({
            endPoint: `piles/step-details?pileId=${data?.id}&stepNumber=${data2.number}&stepName=${data2.name}`,
          })
        );
      }
    }
    // eslint-disable-next-line
  }, [step]);

  return (
    <div className="right_drawer_page p1">
      <Grid className="flex_between">
        <Text
          type="normal"
          fonts="normal"
          fontSize={18}
          className="fw500 mt0 mb0"
        >
          Plie {pileLevelDetail?.name} Details
        </Text>
        <span className="pointer" onClick={() => props.setDrawerOpen(false)}>
          <SVG type="close" />
        </span>
      </Grid>
      {/* -------  Pile Level Details -------- */}
      <Grid>
        <Text
          type="normal"
          fonts="normal"
          fontSize={17}
          className="fw500 mt0 mb0"
        >
          Plie Level Details
        </Text>
        <Grid className="p">
          <Text
            type="normal"
            fonts="normal"
            fontSize={14}
            className="fw400 mt0 mb0 flex_between"
          >
            <span> Pile Work Started On </span>
            <span className={`fw500 capitalize`}>
              {dateFormat(pileLevelDetail?.startedOn?.slice(0, 10))}
            </span>
          </Text>

          {!["completed", "completed with delay"].includes(
            pileLevelDetail?.status
          ) && (
            <Text
              type="normal"
              fonts="normal"
              fontSize={14}
              className="fw400 mt0 mb0 flex_between"
            >
              <span> Step in Progress </span>
              <span className={`fw500 capitalize`}>
                {pileLevelDetail?.stepName}, {pileLevelDetail?.stepNumber}
              </span>
            </Text>
          )}

          <Text
            type="normal"
            fonts="normal"
            fontSize={14}
            className="fw400 mt0 mb0 flex_between"
          >
            <span> Location </span>
            <span className={`fw500 capitalize`}>
              {pileLevelDetail?.location}
            </span>
          </Text>
          <Text
            type="normal"
            fonts="normal"
            fontSize={14}
            className="fw400 mt0 mb0 flex_between"
          >
            <span> Pile Status </span>
            <span
              className={`fw500 capitalize ${
                pileLevelDetail?.status === "completed with delay"
                  ? "text--danger"
                  : pileLevelDetail?.status === "completed" && "text--success"
              }`}
            >
              {" "}
              {pileLevelDetail?.status}{" "}
            </span>
          </Text>

          <Text
            type="normal"
            fonts="normal"
            fontSize={14}
            className="fw400 mt0 mb0 flex_between"
          >
            <span> Last Worked By </span>
            <span className={`fw500 capitalize`}>
              {pileLevelDetail?.lastWorkedBy}
            </span>
          </Text>
        </Grid>
      </Grid>
      {/* -------  Pile Level Details -------- */}
      {/* ----------  Step Level Details --------- */}
      <Grid className="mt_low_space">
        <Text
          type="normal"
          fonts="normal"
          fontSize={17}
          className="fw500 mt0 mb0"
        >
          Step Level Details
        </Text>
        <SelectBox
          data={stepsDropData}
          placeHolder="Select Project"
          defaultVal={step}
          onChange={(e) => setStep(e.target.value)}
          borderColor={"primary"}
        />
        {stepLevelDetail && (
          <Grid className="p capitalize">
            <Grid>
              {stepLevelDetail?.startedOn && (
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="fw400 mt0 mb0 d-flex sb"
                >
                  <span>Step Work Started on</span>
                  <span>
                    {" "}
                    {`${dateFormat(
                      stepLevelDetail?.startedOn?.split("T")[0]
                    )} ${timeFormatter(
                      new Date(stepLevelDetail?.startedOn)
                    ).toLocaleUpperCase()}`}{" "}
                  </span>
                </Text>
              )}

              {stepLevelDetail?.completedOn &&
                stepLevelDetail?.status?.slice(0, 9).toLowerCase() ===
                  "completed" && (
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="fw400 mb0 d-flex sb mt_low_space"
                  >
                    <span>Step Work Completed on</span>
                    <span>
                      {`${dateFormat(
                        stepLevelDetail?.completedOn?.split("T")[0]
                      )} ${timeFormatter(
                        new Date(stepLevelDetail?.completedOn)
                      ).toLocaleUpperCase()}`}
                    </span>
                  </Text>
                )}

              {stepLevelDetail?.machineUsed && (
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="fw400 mb0 d-flex sb mt_low_space"
                >
                  <span>Machine Used</span>
                  <span>{stepLevelDetail?.machineUsed}</span>
                </Text>
              )}

              {stepLevelDetail?.startedBy && (
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={14}
                  className="fw400 mb0 d-flex sb mt_low_space"
                >
                  <span>Step Work Started by</span>
                  <span className="capitalize">
                    {stepLevelDetail?.startedBy}
                  </span>
                </Text>
              )}

              {stepLevelDetail?.completedBy &&
                stepLevelDetail?.status?.slice(0, 9).toLowerCase() ===
                  "completed" && (
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="fw400 mb0 d-flex sb mt_low_space"
                  >
                    <span>Step Work Completed by</span>
                    <span className="capitalize">
                      {stepLevelDetail?.completedBy}
                    </span>
                  </Text>
                )}

              <Text
                type="normal"
                fonts="normal"
                fontSize={14}
                className="fw400 mb0 d-flex sb mt_low_space"
              >
                <span>Completion Status</span>
                <span>{stepLevelDetail?.status}</span>
              </Text>

              {stepLevelDetail?.status?.toLowerCase() ===
                "completed with delay" && (
                <Grid>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="fw400 mb0 d-flex sb mt_low_space"
                  >
                    <span>Delay Period</span>
                    <span>
                      {+stepLevelDetail?.delay?.period[0]?.toFixed(2)}
                    </span>
                  </Text>

                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="fw400 mb0 d-flex sb mt_low_space"
                  >
                    <span>Delay Agency</span>
                    <span>{stepLevelDetail?.delay?.responsibleAgency[0]}</span>
                  </Text>

                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="fw400 mb0 d-flex sb mt_low_space"
                  >
                    <span>Delay Reason</span>
                    <span>{stepLevelDetail?.delay?.reason[0]}</span>
                  </Text>
                </Grid>
              )}
            </Grid>

            {step.substring(step.length - 16) !== "Pile forecasting" && (
              <Grid className="flex_between">
                <Grid>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="fw300"
                  >
                    Starting Snapshot
                  </Text>
                  <img
                    src={stepLevelDetail?.stepImages?.startPoint}
                    alt="N/A"
                    height="70"
                  />
                </Grid>
                <Grid>
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="fw300"
                  >
                    Completion Snapshot
                  </Text>
                  <img
                    src={stepLevelDetail?.stepImages?.endPoint}
                    alt="N/A"
                    height="70"
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        )}
      </Grid>
      {/* ----------  Step Level Details --------- */}
      {/* ----------  Engineer Level Details --------- */}
      <Grid className="mt_low_space">
        <Text
          type="normal"
          fonts="normal"
          fontSize={17}
          className="fw500 mt0 mb0"
        >
          Engineer Level Details
        </Text>
        <SelectBox
          data={["Morning Shift", "Night Shift"]}
          placeHolder="Select Shift"
          value={shift.long}
          defaultVal={shift.long}
          onChange={(e) => {
            setShift({
              short: e.target.value === "Morning Shift" ? "DAY" : "NIGHT",
              long: e.target.value,
            });
          }}
          borderColor={"primary"}
        />
        {engineerLevelDetail?.map((item: any, index: number) => (
          <Grid className="p">
            {engineerLevelDetails?.slice(0, 2).map((val: any) => {
              return (
                <Grid
                  className={`${
                    val.label !== "Engineer Name" && "mt_low_space"
                  }`}
                >
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={14}
                    className="fw400 mt0 mb0 flex_between"
                  >
                    <span> {val.label} </span>
                    <span
                      className={`fw500 ${
                        val.label === "Engineer Name" && "capitalize"
                      }`}
                    >
                      {" "}
                      {val.label === "Engineer Name"
                        ? item.name
                        : item.empId}{" "}
                    </span>
                  </Text>
                </Grid>
              );
            })}
            <Grid className="box--shadow p mt_low_space">
              <Grid className="flex_between" onClick={startStepToggle}>
                <span className="fw500 f14">Steps Started</span>
                <span className="fw400 pointer">
                  {" "}
                  {engStartStep ? (
                    <span className="fw400 f18">-</span>
                  ) : (
                    <span className="fw400 f18">+</span>
                  )}{" "}
                </span>
              </Grid>
              <Grid>
                {engStartStep &&
                  item?.stepsStarted?.map((val: any, index: number) => {
                    return (
                      <Grid className="">
                        <Text
                          type="normal"
                          fonts="normal"
                          fontSize={14}
                          className="fw400 mt0 mb0 capitalize"
                        >
                          <span>
                            {" "}
                            {val.stepNumber}, {val.stepName}{" "}
                          </span>
                        </Text>
                      </Grid>
                    );
                  })}
              </Grid>
            </Grid>
            <Grid className="box--shadow p mt_low_space">
              <Grid className="flex_between" onClick={completedStepToggle}>
                {" "}
                <span className="fw500 f14">Steps Completed</span>
                <span className="fw400 pointer">
                  {" "}
                  {engCompletedStep ? (
                    <span className="fw400 f18">-</span>
                  ) : (
                    <span className="fw400 f18">+</span>
                  )}{" "}
                </span>
              </Grid>
              <Grid>
                {engCompletedStep &&
                  item?.stepsCompleted?.map((val: any, index: number) => {
                    return (
                      <Grid className="">
                        <Text
                          type="normal"
                          fonts="normal"
                          fontSize={14}
                          className="fw400 mt0 mb0 capitalize"
                        >
                          <span>
                            {" "}
                            {val.stepNumber}, {val.stepName}{" "}
                          </span>
                        </Text>
                      </Grid>
                    );
                  })}
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
      {/* ----------  Engineer Level Details --------- */}
    </div>
  );
};

export default WorkInProgressPilesDrawer;
